function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import DraftEditor from "./DraftEditor/DraftEditor";

const TexteditorField = (_ref) => {
  let label = _ref.label,
      helperText = _ref.helperText,
      value = _ref.value,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["label", "helperText", "value", "onChange"]);

  return React.createElement(DraftEditor, {
    label: label,
    helperText: helperText,
    value: value,
    onChange: onChange
  });
};

export default TexteditorField;